import {useEffect, useState} from "react";
import "./DigitalClock.scss"
import {Player} from "@lottiefiles/react-lottie-player";
import * as React from "react";
import errorType from '../../../assets/lottie/man_travel_hotel.json'
import {
    convertUniversalDateToPersianDateFullInfo,
    convertUniversalTimeToPersianTime, RaikoBaseCardContainer
} from "@moeindal/base-raiko-panel-components";

export default function DigitalClock() {

    const [value, setValue] = useState(new Date());
    const [time, setTime] = useState("00:00:00");
    const [persianDate, setPersianDate] = useState(convertUniversalDateToPersianDateFullInfo(JSON.stringify(new Date())));


    useEffect(() => {
        const interval = setInterval(() => {
            const date = new Date()
            setPersianDate(convertUniversalDateToPersianDateFullInfo(JSON.stringify(date)))
            setValue(date)
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (typeof value !== 'undefined') {
            setTime(convertUniversalTimeToPersianTime(value))
        }
    }, [value]);

    return (
        <RaikoBaseCardContainer className={"baseDigitalClockContainer"}>
            <div className={"digitalClockInfoContainer"}>
                <span className={"digitalClockText"}>{time}</span>
                <span
                    className={"digitalClockPersianDateText"}>
                {
                    persianDate
                }
                </span>
                <span className={"digitalClockUniversalDateText"}>
                    {
                        `
                        ${new Intl.DateTimeFormat('ar-TN-u-ca-islamic', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                        }).format(Date.now())}
                        |
                        ${
                            new Date().toLocaleDateString('en-US', {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            })
                        }
                        `
                    }
                </span>
            </div>

            {/*<div>*/}
            {/*    <Player*/}
            {/*        src={errorType}*/}
            {/*        loop*/}
            {/*        autoplay*/}
            {/*        style={{height: '150px', width: '150px'}}*/}
            {/*    />*/}
            {/*</div>*/}
        </RaikoBaseCardContainer>
    )
}
